export const canvasActionTypes = {
    // FETCH DIAGRAM MEMBERS
    FETCH_DIAGRAM_MEMBERS_REQUEST: 'C1',
    FETCH_DIAGRAM_MEMBERS_SUCCESS: 'C2',
    FETCH_DIAGRAM_MEMBERS_FAILURE: 'C3',

    // CHANGE ROLE FOR DIAGRAM MEMBER
    CHANGE_MEMBER_ROLE_REQUEST: 'C4',
    CHANGE_MEMBER_ROLE_SUCCESS: 'C5',
    CHANGE_MEMBER_ROLE_FAILURE: 'C6',

    // REMOVE DIAGRAM MEMBER
    REMOVE_DIAGRAM_MEMBER_REQUEST: 'C7',
    REMOVE_DIAGRAM_MEMBER_SUCCESS: 'C8',
    REMOVE_DIAGRAM_MEMBER_FAILURE: 'C9',

    // FETCH DIAGRAM INVITES
    FETCH_DIAGRAM_INVITES_REQUEST: 'C10',
    FETCH_DIAGRAM_INVITES_SUCCESS: 'C11',
    FETCH_DIAGRAM_INVITES_FAILURE: 'C12',

    // CREATE DIAGRAM INVITE
    CREATE_DIAGRAM_INVITE_REQUEST: 'C13',
    CREATE_DIAGRAM_INVITE_SUCCESS: 'C14',
    CREATE_DIAGRAM_INVITE_FAILURE: 'C15',

    // REVOKE DIAGRAM INVITE
    REVOKE_DIAGRAM_INVITE_REQUEST: 'C16',
    REVOKE_DIAGRAM_INVITE_SUCCESS: 'C17',
    REVOKE_DIAGRAM_INVITE_FAILURE: 'C18',
};






// export const canvasActionTypes = {
//     // FETCH DIAGRAM MEMBERS
//     FETCH_DIAGRAM_MEMBERS_REQUEST: 'FETCH_DIAGRAM_MEMBERS_REQUEST',
//     FETCH_DIAGRAM_MEMBERS_SUCCESS: 'FETCH_DIAGRAM_MEMBERS_SUCCESS',
//     FETCH_DIAGRAM_MEMBERS_FAILURE: 'FETCH_DIAGRAM_MEMBERS_FAILURE',

//     // CHANGE ROLE FOR DIAGRAM MEMBER
//     CHANGE_MEMBER_ROLE_REQUEST: 'CHANGE_MEMBER_ROLE_REQUEST',
//     CHANGE_MEMBER_ROLE_SUCCESS: 'CHANGE_MEMBER_ROLE_SUCCESS',
//     CHANGE_MEMBER_ROLE_FAILURE: 'CHANGE_MEMBER_ROLE_FAILURE',

//     // REMOVE DIAGRAM MEMBER
//     REMOVE_DIAGRAM_MEMBER_REQUEST: 'REMOVE_DIAGRAM_MEMBER_REQUEST',
//     REMOVE_DIAGRAM_MEMBER_SUCCESS: 'REMOVE_DIAGRAM_MEMBER_SUCCESS',
//     REMOVE_DIAGRAM_MEMBER_FAILURE: 'REMOVE_DIAGRAM_MEMBER_FAILURE',

//     // FETCH DIAGRAM INVITES
//     FETCH_DIAGRAM_INVITES_REQUEST: 'FETCH_DIAGRAM_INVITES_REQUEST',
//     FETCH_DIAGRAM_INVITES_SUCCESS: 'FETCH_DIAGRAM_INVITES_SUCCESS',
//     FETCH_DIAGRAM_INVITES_FAILURE: 'FETCH_DIAGRAM_INVITES_FAILURE',

//     // CREATE DIAGRAM INVITE
//     CREATE_DIAGRAM_INVITE_REQUEST: 'CREATE_DIAGRAM_INVITE_REQUEST',
//     CREATE_DIAGRAM_INVITE_SUCCESS: 'CREATE_DIAGRAM_INVITE_SUCCESS',
//     CREATE_DIAGRAM_INVITE_FAILURE: 'CREATE_DIAGRAM_INVITE_FAILURE',

//     // REVOKE DIAGRAM INVITE
//     REVOKE_DIAGRAM_INVITE_REQUEST: 'REVOKE_DIAGRAM_INVITE_REQUEST',
//     REVOKE_DIAGRAM_INVITE_SUCCESS: 'REVOKE_DIAGRAM_INVITE_SUCCESS',
//     REVOKE_DIAGRAM_INVITE_FAILURE: 'REVOKE_DIAGRAM_INVITE_FAILURE',
// };
